function salutCartDrawer() {
  return document.querySelector('cart-drawer');
}

function salutCartDrawerReveal(panel) {
  if (!panel || !panel.parentElement || typeof initializeScrollAnimationTrigger !== 'function') return;
  initializeScrollAnimationTrigger(panel.parentElement);
}

const SALUT_RECO_DISMISSED = 'salut-cart-reco-dismissed';
const SALUT_LIST_SELECTOR = '.salut-cart__list';
let salutCartListScrollTop = 0;

function salutCartDrawerRecoIsDismissed() {
  try {
    return sessionStorage.getItem(SALUT_RECO_DISMISSED) === '1';
  } catch (error) {
    return false;
  }
}

function salutCartDrawerRecoDismiss() {
  try {
    sessionStorage.setItem(SALUT_RECO_DISMISSED, '1');
  } catch (error) {
    /* modul privat fara sessionStorage: panoul revine la urmatoarea randare */
  }
}

function salutCartDrawerStoreListScroll() {
  const list = salutCartDrawer()?.querySelector(SALUT_LIST_SELECTOR);
  if (list) salutCartListScrollTop = list.scrollTop;
}

function salutCartDrawerRestoreListScroll() {
  if (!salutCartListScrollTop) return;
  const list = salutCartDrawer()?.querySelector(SALUT_LIST_SELECTOR);
  if (!list) return;
  list.scrollTop = Math.min(salutCartListScrollTop, list.scrollHeight - list.clientHeight);
}

function salutCartDrawerFetchReco() {
  const drawer = salutCartDrawer();
  if (!drawer) return;

  salutCartDrawerRestoreListScroll();

  const panel = drawer.querySelector('[data-salut-reco]');

  if (panel && salutCartDrawerRecoIsDismissed()) {
    panel.remove();
    return;
  }

  salutCartDrawerReveal(panel);

  if (panel) {
    salutCartDrawerRecoNavUpdate(panel);
  }

  const track = drawer.querySelector('[data-salut-reco-track][data-url]');
  if (!track || track.dataset.fetching === 'true') return;

  track.dataset.fetching = 'true';

  fetch(track.dataset.url)
    .then((response) => response.text())
    .then((text) => {
      const doc = new DOMParser().parseFromString(text, 'text/html');
      const fresh = doc.querySelector('[data-salut-reco-track]');

      if (!fresh || !fresh.children.length) {
        panel?.remove();
        return;
      }

      track.innerHTML = fresh.innerHTML;
      track.removeAttribute('data-url');
      salutCartDrawerRecoNavUpdate(panel);
    })
    .catch((error) => {
      console.error(error);
    })
    .finally(() => {
      delete track.dataset.fetching;
    });
}

function salutCartDrawerRecoNavUpdate(panel) {
  if (!panel) return;

  const track = panel.querySelector('[data-salut-reco-track]');
  const prevButton = panel.querySelector('[data-reco-prev]');
  const nextButton = panel.querySelector('[data-reco-next]');
  if (!track || !prevButton || !nextButton) return;

  const maxScroll = track.scrollWidth - track.clientWidth;
  prevButton.disabled = track.scrollLeft <= 0;
  nextButton.disabled = track.scrollLeft >= maxScroll - 1;
  track.classList.toggle('is-draggable', maxScroll > 1);
}

function salutCartDrawerRecoGlide(track, velocity) {
  if (Math.abs(velocity) < 0.05) return;

  let speed = velocity;
  let previous = null;

  const step = (now) => {
    if (previous === null) {
      previous = now;
      requestAnimationFrame(step);
      return;
    }

    const elapsed = Math.min(now - previous, 32);
    previous = now;

    const before = track.scrollLeft;
    track.scrollLeft = before - speed * elapsed;
    speed *= Math.pow(0.9965, elapsed);

    if (Math.abs(speed) < 0.02 || Math.abs(track.scrollLeft - before) < 0.5) {
      track.classList.remove('is-gliding');
      return;
    }

    requestAnimationFrame(step);
  };

  track.classList.add('is-gliding');
  requestAnimationFrame(step);
}

function salutCartDrawerRecoDrag(drawer) {
  const DRAG_THRESHOLD = 4;
  let track = null;
  let pointerId = null;
  let startX = 0;
  let startScroll = 0;
  let moved = false;
  let suppressClick = false;
  let lastX = 0;
  let lastTime = 0;
  let velocity = 0;

  const stop = () => {
    if (!track) return;
    if (track.hasPointerCapture && pointerId !== null && track.hasPointerCapture(pointerId)) {
      track.releasePointerCapture(pointerId);
    }
    track.classList.remove('is-dragging');
    suppressClick = moved;
    if (moved) salutCartDrawerRecoGlide(track, velocity);
    track = null;
    pointerId = null;
    moved = false;
    velocity = 0;
  };

  drawer.addEventListener('pointerdown', (event) => {
    if (event.pointerType !== 'mouse' || event.button !== 0) return;

    const candidate = event.target.closest('[data-salut-reco-track]');
    if (!candidate || candidate.scrollWidth - candidate.clientWidth <= 1) return;

    track = candidate;
    pointerId = event.pointerId;
    startX = event.clientX;
    startScroll = candidate.scrollLeft;
    moved = false;
    lastX = event.clientX;
    lastTime = event.timeStamp;
    velocity = 0;
    candidate.classList.remove('is-gliding');
  });

  drawer.addEventListener('pointermove', (event) => {
    if (!track || event.pointerId !== pointerId) return;

    const delta = event.clientX - startX;
    if (!moved) {
      if (Math.abs(delta) < DRAG_THRESHOLD) return;
      moved = true;
      track.classList.add('is-dragging');
      track.setPointerCapture(pointerId);
    }

    event.preventDefault();
    track.scrollLeft = startScroll - delta;

    const span = event.timeStamp - lastTime;
    if (span > 0) {
      const sample = (event.clientX - lastX) / span;
      velocity = velocity * 0.7 + sample * 0.3;
      lastX = event.clientX;
      lastTime = event.timeStamp;
    }
  });

  drawer.addEventListener('pointerup', stop);
  drawer.addEventListener('pointercancel', stop);

  drawer.addEventListener(
    'click',
    (event) => {
      if (!suppressClick) return;
      suppressClick = false;
      event.preventDefault();
      event.stopPropagation();
    },
    true
  );

  drawer.addEventListener('dragstart', (event) => {
    if (event.target.closest('[data-salut-reco-track]')) event.preventDefault();
  });
}

function salutCartDrawerRecoScroll(panel, direction) {
  const track = panel.querySelector('[data-salut-reco-track]');
  const card = track?.querySelector('.salut-cart__reco-card');
  if (!track || !card) return;

  const gap = parseFloat(getComputedStyle(track).columnGap) || 0;
  track.scrollBy({ left: direction * (card.getBoundingClientRect().width + gap), behavior: 'smooth' });
}

function salutCartDrawerAdd(button) {
  if (button.getAttribute('aria-disabled') === 'true') return;

  const drawer = salutCartDrawer();
  const body = {
    items: [{ id: parseInt(button.dataset.variantId, 10), quantity: 1 }],
  };

  if (drawer) {
    body.sections = drawer.getSectionsToRender().map((section) => section.id);
    body.sections_url = window.location.pathname;
  }

  button.setAttribute('aria-disabled', 'true');
  button.classList.add('is-loading');

  const config = fetchConfig('javascript');
  config.body = JSON.stringify(body);

  fetch(routes.cart_add_url, config)
    .then((response) => response.json())
    .then((response) => {
      if (response.status) {
        publish(PUB_SUB_EVENTS.cartError, {
          source: 'salut-cart-drawer',
          errors: response.errors || response.description,
          message: response.message,
        });
        return;
      }

      if (drawer && response.sections) {
        drawer.classList.remove('is-empty');
        drawer.renderContents(response);
      }

      publish(PUB_SUB_EVENTS.cartUpdate, {
        source: 'salut-cart-drawer',
        cartData: response,
      });
    })
    .catch((error) => {
      console.error(error);
    })
    .finally(() => {
      button.removeAttribute('aria-disabled');
      button.classList.remove('is-loading');
    });
}

(function initSalutCartDrawerReco() {
  const drawer = salutCartDrawer();
  if (!drawer) return;

  subscribe(PUB_SUB_EVENTS.cartOpen, salutCartDrawerFetchReco);
  subscribe(PUB_SUB_EVENTS.cartUpdate, salutCartDrawerFetchReco);
  subscribe(PUB_SUB_EVENTS.cartRemove, salutCartDrawerFetchReco);

  drawer.querySelectorAll('[data-salut-reco]').forEach((panel) => salutCartDrawerRecoNavUpdate(panel));
  salutCartDrawerRecoDrag(drawer);

  drawer.addEventListener('click', (event) => {
    if (event.target.closest('quantity-input button, cart-remove-button')) {
      salutCartDrawerStoreListScroll();
    }

    const closeButton = event.target.closest('[data-salut-reco-close]');
    if (closeButton) {
      salutCartDrawerRecoDismiss();
      closeButton.closest('[data-salut-reco]')?.remove();
      return;
    }

    const addButton = event.target.closest('[data-salut-reco-add]');
    if (addButton) {
      salutCartDrawerAdd(addButton);
      return;
    }

    const prevButton = event.target.closest('[data-reco-prev]');
    if (prevButton && !prevButton.disabled) {
      salutCartDrawerRecoScroll(prevButton.closest('[data-salut-reco]'), -1);
      return;
    }

    const nextButton = event.target.closest('[data-reco-next]');
    if (nextButton && !nextButton.disabled) {
      salutCartDrawerRecoScroll(nextButton.closest('[data-salut-reco]'), 1);
    }
  });

  drawer.addEventListener(
    'scroll',
    (event) => {
      const track = event.target.closest ? event.target.closest('[data-salut-reco-track]') : null;
      if (track) {
        salutCartDrawerRecoNavUpdate(track.closest('[data-salut-reco]'));
      }
    },
    true
  );

  window.addEventListener('resize', () => {
    drawer.querySelectorAll('[data-salut-reco]').forEach((panel) => salutCartDrawerRecoNavUpdate(panel));
  });
})();
